'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'explosion';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e4e9';
var svgPathData = 'M312-32l-48 0 0 96 48 0 0-96zM144 368l-144-48 82.3 96 115.2 0c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64l115.2 0 82.3-96-144 48 112-368-208 296-24-168-48 0-24 176-144-112 48 176zM24 464l-24 0 0 48 576 0 0-48-552 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faExplosion = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;